<article class="card" [attr.data-tier]="vm?.tier">
  <p class="card__title">{{ vm?.title }}</p>
  <p class="card__figure">
    <span class="card__percent">{{ vm?.percentLabel }}</span>
    <span class="card__count">{{ vm?.countLabel }}</span>
  </p>
  <mat-progress-bar
    class="card__progress mat-progress-bar-sm"
    mode="determinate"
    [value]="vm?.progressPercent ?? 0"
    [attr.aria-label]="vm?.title"
  ></mat-progress-bar>
</article>
